import { parsePhoneNumberFromString } from 'libphonenumber-js'

// Numbers stored without a country code can't be parsed, so they show as entered.
export const formatPhone = (phone: string): string =>
  parsePhoneNumberFromString(phone)?.formatInternational() ?? phone
